import StudentSummaryPage from './StudentSummaryPage';

export default StudentSummaryPage;
